import { useQuery } from '@tanstack/react-query';
import { useToast } from '@/components/atoms/Toast';
import { getMapBoxKey } from '@/services/apiKeyService';

export const useMapboxKeyQuery = () => {
	const { toast } = useToast();

	return useQuery({
		queryKey: ['mapbox-key'],
		queryFn: getMapBoxKey,
		onError: error => {
			// eslint-disable-next-line no-console
			console.error({ error });

			const errorMessage = {
				title: 'Something unexpected happened',
				description: 'Please try again or contact support'
			};

			toast({
				...errorMessage,
				variant: 'error'
			});
		}
	});
};
